
import React from 'react';
import ImageGallery from 'react-image-gallery';
import { images } from './images';
import './CarouselTop.scss';
import "react-image-gallery/styles/scss/image-gallery.scss";

const CarouselTop = () => {

  	return (
		<div id="carousel-top" className="carousel-top">    
			<ImageGallery  
				items={images} 
				showThumbnails={false} 
				showFullscreenButton={false}
				showPlayButton={false}
				showBullets
				autoPlay
				slideInterval={6000}
			/>
		</div>
  	);
}

export default CarouselTop;
